<button type="button" 
    class="lexus-btn-primary"
    [ngClass]="buttonConfig['size'] === 'sm' ? 'lexus-sm' : 'lexus-lg'"
    (click)="onClickButton($event)">
    {{ buttonConfig.text}}
</button>